module.exports = __webpack_public_path__ + "static/AtlasGrotesk-Medium-Web-5e367ac7be85088e6be843da2067768f.woff";